import { animated, useSpring } from '@react-spring/web';
import * as React from 'react';

interface ToggleAnimationWrapperProps {
	isVisible: boolean;
	children: React.ReactNode;
	duration?: number;
	className?: string;
	style?: React.CSSProperties;
}

export const ToggleAnimationWrapper: React.FC<ToggleAnimationWrapperProps> = ({
	isVisible,
	children,
	duration = 400,
	className,
	style,
}) => {
	const animation = useSpring({
		from: {
			height: 0,
			opacity: 0,
			overflow: 'hidden',
			position: 'absolute',
			top: 0,
		},
		to: {
			height: isVisible ? 'auto' : 0,
			opacity: isVisible ? 1 : 0,
			overflow: isVisible ? 'visible' : 'hidden',
			position: isVisible ? 'relative' : 'absolute',
			top: isVisible ? 0 : 50,
		},
		config: {
			duration,
		},
	});

	return (
		<animated.div style={{ ...animation, ...style } as any} className={className}>
			{children}
		</animated.div>
	);
};
